import { WEBCOIN_SECTIONS } from '@wwe-portal/web/utils/constants/webcoin';
import { useTranslations } from 'next-intl';
import RefreshTimer from '../refresh-timer/refresh-timer';
import { Each } from '@wwe-portal/ui/components/utils';
import { Frame } from '@wwe-portal/entities/webcoin.type';
import WebCoinShopCardResponsive from '../web-coin-shop-card/web-coin-shop-card-mobile';
import { Button } from '@wwe-portal/ui/components/button';
import { useState } from 'react';

export const AvatarFrameListMobile = ({
  ref,
  pacificDate,
  handleUpdateLiveList,
  framesList,
  handleItemsPurchase,
  purchasingOffer,
  isPaymentSuccess,
}: {
  ref: React.RefObject<HTMLDivElement | null>;
  pacificDate: string;
  handleUpdateLiveList: () => void;
  framesList: Frame[];
  handleItemsPurchase: ({ price, itemId, type, title }) => void;
  purchasingOffer: any;
  isPaymentSuccess: boolean;
}) => {
  const t = useTranslations();
  const [currentIndex, setCurrentIndex] = useState(3);

  const handleViewAll = () => {
    setCurrentIndex(currentIndex + 3);
  };

  return (
    <div className="mb-[25px]" id={WEBCOIN_SECTIONS.AVATAR_FRAMES}>
      <div
        ref={ref}
        className="shop-featured mb-[10px] flex justify-between pt-0"
      >
        <h4 className="mb-0 text-base font-semibold">{t('avatar_frames')}</h4>
        {pacificDate && (
          <RefreshTimer
            time={pacificDate}
            handleTimerFromChild={handleUpdateLiveList}
          />
        )}
      </div>
      <p className={`text-text600 mb-8 text-xs`}>
        {t('avatar_frames_description')}
      </p>
      <Each
        data={framesList.slice(0, currentIndex)}
        render={(item: Frame, index) => (
          <div key={index} className="mb-[10px]">
            <WebCoinShopCardResponsive
              title={item.displayName || 'Avatar'}
              rarity={item.rarity}
              image={item.image}
              price={item.price}
              id={item.frameId}
              unlocked={item.unlocked}
              handlePurchaseClick={(price, itemId, type) =>
                handleItemsPurchase({
                  price,
                  itemId,
                  type,
                  title: item.displayName,
                })
              }
              listType="frame"
              paymentLoading={purchasingOffer?.offerId === item.frameId}
              showModal={!isPaymentSuccess}
              data={item}
            />
          </div>
        )}
      />
      {framesList?.length > 3 && currentIndex < framesList.length ? (
        <Button
          onClick={() => handleViewAll()}
          variant="secondary"
          className="bg-back200 mt-[10px] flex h-10 w-full items-center justify-center rounded-md border-0 py-[10px] text-base font-semibold text-white"
        >
          {t('view_more')}
        </Button>
      ) : null}
    </div>
  );
};
